import React, { useState, useEffect } from "react";
import { ENotificationTest } from "../../../Model/ENotificationTest";
import { SmtpSetting } from "../../../Model/SmtpSetting";
import { TestEmail, NotificationTest } from "../../../Model/TestEmail";
import CheckBox from "../../Buttons/CheckBox";
import RadioButton from "../../Buttons/RadioButton";
import ToolsContent from "../ToolsCommon/ToolsContent";
import ToolsContentButton from "../ToolsCommon/ToolsContentButton";
import ToolsContentTextArea from "../ToolsCommon/ToolsContentTextArea";
import ToolsContentTextBox from "../ToolsCommon/ToolsContentTextBox";
import ToolsContentTextBoxPassword from "../ToolsCommon/ToolsContentTextBoxPassword";
import IconInfo from "../../../Icons/NotificationMessage/Info";
import UserUtil from "../../../Utility/UserUtil";
import ToolsApi from "../../../api/ToolsApi";
import MtiButton from "../../Buttons/MtiButton";
import { sendNotification } from "../../../redux/actions/NotificationAction";
import { ENotificationType } from "../../../Model/ENotificationType";
import { getDispatch } from "../../../redux/configureStore";

const initialNotificationTest: NotificationTest = {
  notificationTest: ENotificationTest.Email,
  testEmail: {
    smtp: {
      server: "-",
      port: 25,
      username: "-",
      password: "-",
      enableSsl: false,
    },
    to: "-", //"fitriadi.nugroho@formulatrix.com",
    from: "-", //"forindo.salatiga@gmail.com",
    subject: "-", //"Test Email",
    body: "-", //"Test Email From MTI UI",
  },
};

type Props = {
  disabled: boolean;
};

export default function CustomEmail({ disabled }: Props) {
  const dispatch = getDispatch();
  const [notificationTestEmail, setNotificationTestEmail] = useState(
    initialNotificationTest
  );

  const onSmtpChange = (smtp: SmtpSetting) => {
    setNotificationTestEmail({
      ...notificationTestEmail,
      testEmail: {
        ...notificationTestEmail.testEmail,
        smtp: smtp,
      },
    });
  };

  const onEmailTestChange = (value: string, field: keyof TestEmail) => {
    setNotificationTestEmail({
      ...notificationTestEmail,
      testEmail: {
        ...notificationTestEmail.testEmail,
        [field]: value,
      },
    });
  };

  const emailToisValidFormat = UserUtil.IsValidEmailFormat(
    notificationTestEmail.testEmail.to
  );
  const emailFromisValidFormat = UserUtil.IsValidEmailFormat(
    notificationTestEmail.testEmail.from
  );

  useEffect(() => {
    ToolsApi.getSmtpSetting().then((smtp) => {
      onSmtpChange(smtp);
    });
  }, []);

  const onClickSend = () => {
    ToolsApi.sendTestEmail(notificationTestEmail).then(
      (succes) => {
        dispatch(
          sendNotification(ENotificationType.Success, "Email has been sent.")
        );
      },
      (error) => console.log(error)
    );
  };
  return (
    <div
      style={{
        display: "grid",
        gridTemplateAreas: `'ssl ssl'
                            'server username' 
                            'port password'
                            'to from'
                            'subject subject'
                            'body body'
                            'send send'`,
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto",
        gridRowGap: "22px",
        gridColumnGap: "50px",
        overflow: "auto",
      }}
    >
      <CheckBox
        colorVariant="alternate"
        id="enableSsl"
        label="Enable Secure Socket Layer (SSL)"
        name="enableSsl"
        checked={notificationTestEmail.testEmail.smtp.enableSsl}
        onChange={(id, value) =>
          onSmtpChange({
            ...notificationTestEmail.testEmail.smtp,
            enableSsl: value,
          })
        }
        style={{
          gridArea: "ssl",
          fontSize: "14px",
          marginTop: 10,
          marginBottom: 8,
          marginLeft: 7,
        }}
        disabled={disabled}
      />
      <ToolsContentTextBox
        label="Server"
        name="server"
        labelVariant="top-down"
        value={notificationTestEmail.testEmail.smtp.server}
        onChange={(value) =>
          onSmtpChange({
            ...notificationTestEmail.testEmail.smtp,
            server: value as string,
          })
        }
        style={{
          gridArea: "server",
        }}
        labelStyle={{
          maxWidth: 103,
          minWidth: 103,
        }}
        disabled={disabled}
      />
      <ToolsContentTextBox
        label="User Name"
        name="username"
        labelVariant="top-down"
        value={notificationTestEmail.testEmail.smtp.username}
        onChange={(value) =>
          onSmtpChange({
            ...notificationTestEmail.testEmail.smtp,
            username: value as string,
          })
        }
        style={{
          gridArea: "username",
        }}
        labelStyle={{
          maxWidth: 103,
          minWidth: 103,
        }}
        disabled={disabled}
      />
      <ToolsContentTextBoxPassword
        label="Password"
        name="password"
        value={notificationTestEmail.testEmail.smtp.password}
        onChange={(value) =>
          onSmtpChange({
            ...notificationTestEmail.testEmail.smtp,
            password: value as string,
          })
        }
        style={{
          gridArea: "password",
        }}
        labelStyle={{
          maxWidth: 103,
          minWidth: 103,
        }}
        disabled={disabled}
      />
      <ToolsContentTextBox
        label="Port"
        name="port"
        labelVariant="top-down"
        value={notificationTestEmail.testEmail.smtp.port}
        onChange={(value) =>
          onSmtpChange({
            ...notificationTestEmail.testEmail.smtp,
            port: value as number,
          })
        }
        variant={"number"}
        isInteger={true}
        style={{
          gridArea: "port",
        }}
        labelStyle={{
          maxWidth: 103,
          minWidth: 103,
        }}
        disabled={disabled}
      />
      <div
        style={{
          gridArea: "to",
        }}
      >
        <ToolsContentTextBox
          label="To"
          name="to"
          labelVariant="top-down"
          value={notificationTestEmail.testEmail.to}
          onChange={(value) => onEmailTestChange(value as string, "to")}
          labelStyle={{
            maxWidth: 103,
            minWidth: 103,
          }}
          inputStyle={{
            border:
              !emailToisValidFormat && !disabled
                ? "1px solid rgb(201, 41, 50)"
                : "1px solid rgb(65, 64, 66)",
          }}
          disabled={disabled}
        />
        {!emailToisValidFormat && !disabled && (
          <div className="not-email">
            <div style={{ display: "flex" }}>
              <IconInfo fill="#C92932" width="10" height="10" />
            </div>
            <p>the email is not valid!</p>
          </div>
        )}
      </div>
      <div
        style={{
          gridArea: "from",
        }}
      >
        <ToolsContentTextBox
          label="From"
          name="from"
          labelVariant="top-down"
          value={notificationTestEmail.testEmail.from}
          onChange={(value) => onEmailTestChange(value as string, "from")}
          labelStyle={{
            maxWidth: 103,
            minWidth: 103,
          }}
          inputStyle={{
            border:
              !emailFromisValidFormat && !disabled
                ? "1px solid rgb(201, 41, 50)"
                : "1px solid rgb(65, 64, 66)",
          }}
          disabled={disabled}
        />
        {!emailFromisValidFormat && !disabled && (
          <div className="not-email">
            <div style={{ display: "flex" }}>
              <IconInfo fill="#C92932" width="10" height="10" />
            </div>
            <p>the email is not valid!</p>
          </div>
        )}
      </div>
      <ToolsContentTextBox
        label="Subject"
        name="subject"
        labelVariant="top-down"
        value={notificationTestEmail.testEmail.subject}
        onChange={(value) => onEmailTestChange(value as string, "subject")}
        style={{
          gridArea: "subject",
        }}
        labelStyle={{
          maxWidth: 103,
          minWidth: 103,
          marginTop: 8,
        }}
        disabled={disabled}
      />
      <ToolsContentTextArea
        label="Body"
        name="body"
        value={notificationTestEmail.testEmail.body}
        onChange={(value) => onEmailTestChange(value as string, "body")}
        style={{
          gridArea: "body",
          marginTop: 8,
        }}
        disabled={disabled}
      />
      <div
        style={{
          gridArea: "send",
          display: "flex",
          justifyContent: "flex-end"
        }}
      >
        <MtiButton
          variant="primary"
          size="medium"
          style={{
            paddingLeft: 16,
            paddingRight: 16,
          }}
          onClick={onClickSend}
          disabled={disabled || (!emailToisValidFormat || !emailFromisValidFormat)}
        >
          SEND
        </MtiButton>
      </div>
    </div>
  );
}
